import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback } from 'react';
import { Badge, Button } from '@mui/material';
import { Update } from '@mui/icons-material';
import { assertNever } from 'webui/utils/never';
import { useAction, useAppSelector } from 'shared/hooks/redux/hooks';
import { useHasFirmwareUpdate } from 'entities/device.service.upgrades/model/check-firmware';
import { PeripheralUpdateType, } from 'features/device.settings.upgrade-extensions/lib';
import { open_upgrade_dialog } from 'console/device-settings/upgrade-dialog/redux/action';
import { useUpgradeExtensionsDialog } from 'features/device.settings.upgrade-extensions/ui/dialog';
import { ErrorBoundary } from 'shared/components/error-boundary';
export const UpdateButton = memo(function UpdateButtonImpl(props) {
    const { device_id, update_type, only_staff, peripheral_type, title, serial, extension_hw_type, ...rest } = props;
    const is_staff = useAppSelector((state) => state.account.is_staff);
    const has_updates = useHasFirmwareUpdate(device_id);
    const show_need_updates = update_type == PeripheralUpdateType.Main && has_updates;
    const onOpenUpgradeDialog = useAction(open_upgrade_dialog);
    const [UpgradeExtensionsDialog, open] = useUpgradeExtensionsDialog();
    const onClick = useCallback(() => {
        switch (update_type) {
            case PeripheralUpdateType.Main:
                onOpenUpgradeDialog();
                break;
            case PeripheralUpdateType.BOILER_ADAPTER:
            case PeripheralUpdateType.DUT:
            case PeripheralUpdateType.GRAPH_PANEL:
            case PeripheralUpdateType.IO_EXTENSION:
            case PeripheralUpdateType.None:
                if (device_id != null) {
                    open();
                }
                break;
            default:
                assertNever(update_type);
        }
    }, [device_id, update_type, peripheral_type]);
    if (only_staff && !is_staff) {
        return null;
    }
    return (_jsxs(ErrorBoundary, { children: [_jsx(Badge, { badgeContent: show_need_updates ? 1 : 0, color: "error", children: _jsx(Button, { onClick: onClick, variant: "outlined", color: "primary", startIcon: _jsx(Update, {}), size: "small", ...rest, children: title != null ? title : 'Обновить' }) }), serial && extension_hw_type ? (_jsx(UpgradeExtensionsDialog, { device_id: device_id, serial: serial, hw_type: extension_hw_type })) : null] }));
});
